import { Link } from 'react-router-dom'
import './InvolvedAudience.css'

function ForPastors() {
  return (
    <div className="audience-page">
      <div className="audience-panel">
        <h1 className="audience-title">For Pastors</h1>
        <p className="audience-intro">
          Taha Wairua is a faith-based youth agency that bridges local churches
          and local schools through after-school programs focused on spiritual
          health, belonging, and safe relationships.
        </p>

        <section className="audience-section">
          <h2>Why Taha Wairua is needed</h2>
          <ul className="audience-list">
            <li>
              Recent youth data in Aotearoa shows high levels of overwhelm,
              self-harm, bullying, and suicidal thinking.
            </li>
            <li>
              Gen Z is highly open to spirituality and values local community
              support.
            </li>
            <li>
              Local research identified a need for safe after-school spaces and
              youth hubs that address loneliness and belonging.
            </li>
            <li>
              Taha Wairua helps bridge the gap where church spirituality is
              often inaccessible to school-based youth.
            </li>
          </ul>
        </section>

        <section className="audience-section">
          <h2>How church partnership works</h2>
          <p>
            Taha Wairua programs are designed to serve the local school closest
            to the hosting church. They are outreach-oriented and function
            alongside, not instead of, a traditional church youth group.
          </p>
          <p>
            The goal is not pressure or proselytising. It is a safe first point
            of contact where young people can explore faith-based spiritual
            practices in ways that are accessible and relevant.
          </p>
        </section>

        <section className="audience-section">
          <h2>Next steps</h2>
          <p>
            To discuss your church hosting a Taha Wairua program, please get in
            touch via the <Link to="/contact" className="audience-link">Contact</Link>{' '}
            page.
          </p>
        </section>
      </div>
    </div>
  )
}

export default ForPastors
